import { render, staticRenderFns } from "./UDSBonuses.vue?vue&type=template&id=149de6d0"
import script from "./UDSBonuses.vue?vue&type=script&lang=js"
export * from "./UDSBonuses.vue?vue&type=script&lang=js"
import style0 from "./UDSBonuses.vue?vue&type=style&index=0&id=149de6d0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports